import ApiService from "../api.services";

const PostService = {
  list: async function () {
    try {
      const response = await ApiService.get("/api/post");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/post/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  filter: async function (customer, startedAt, finishedAt, service, filter, post = true) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
        post,
      };
      const response = await ApiService.post("/api/prepost/filter", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  summary: async function (customer, startedAt, finishedAt, service, filter, post = true) {
    try {
      const data = {
        customer,
        startedAt,
        finishedAt,
        service,
        filter,
        post,
      };
      const response = await ApiService.post("/api/prepost/filter/summary", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PostService;

export { PostService };
